import React, { useState, useEffect } from "react";
import { NewsItemType, NewsItemPicturetype } from "../../Types/News";
import moment from 'moment';

type Props = {
    data: NewsItemType;
    picture: NewsItemPicturetype;
}

export default function NewsItem({ data, picture }: Props) {

    return (
        <div className="newsItem">
            <div className="newsImage">
                <img src={picture.Url || "../../../main-images/newsImage.png"}></img> 
            </div>
            <div className="newsDescription">
                <a href={`https://viomitra.ru/SingleArticle/${data.Id}`}>{data.Title}</a>
                <p>{moment(data.CreationDate).format('DD.MM.YYYY HH:mm')}</p>
            </div>
        </div>
    )
} 